import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { catchError, throwError } from "rxjs";
import { inject } from "@angular/core";
import { MatSnackBar } from "@angular/material/snack-bar";
import { environment } from '../../../environments/environment';
import { isAlreadyExistError } from '../../api/api-error';

export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const matSnackBar = inject(MatSnackBar);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      const isEvidence404 = error.status === 404 && req.url.includes('/evidence');
      // Duplicate hash is shown in the add-transaction dialog, so it doesn't
      // also need the debug toast. Keyed on the BE error code, not the status:
      // a 500 here is a real server fault and must stay visible.
      const isDuplicateTransaction = isAlreadyExistError(error)
        && req.method === 'POST'
        && req.url.includes('/transactions');
      // 401 is handled by authSessionInterceptor (silent re-login or /401 page)
      const isUnauthorized = error.status === 401;

      if (!environment.production && !isEvidence404 && !isDuplicateTransaction && !isUnauthorized) {
        // Short format for Telegram WebView where no DevTools console is available.
        // e.g. "500 — POST /scam" instead of the full URL.
        const path = new URL(req.url, 'http://x').pathname.replace(/^\/api\/v1/, '');
        matSnackBar.open(`${error.status} — ${req.method} ${path}`, 'Close', { duration: 5000 });
      }
      return throwError(() => error);
    })
  );
};
